/* Extracted from snippets/trust-badges-modals.liquid - pure JS,
   no Liquid interpolation. External + defer to cut HTML payload
   and let the browser cache across pages. */
(function() {
  // Closed sheets stay inert during navigation. Hydrate before binding the
  // controller, and again when a linked-product response replaces EMI.
  function hydrateTrustModals() {
    document.querySelectorAll('template[data-trust-modals]').forEach(function(template) {
      template.replaceWith(template.content);
    });
  }
  hydrateTrustModals();
  // Store scroll position
  let scrollPosition = 0;
  
  // Check if mobile
  function isMobile() {
    return window.innerWidth < 768;
  }
  
  // Move all known modals to document.body so they can render on top of overlays without being clipped by parent stacking contexts.
  // Defer to DOMContentLoaded if the parser hasn't reached the modal markup yet.
  function relocateModals() {
    hydrateTrustModals();
    ['service-modal', 'warranty-modal', 'return-modal', 'cod-modal', 'store-pickup-modal', 'purchase-protection-modal', 'emi-modal'].forEach(function(id) {
      const modal = document.getElementById(id);
      if (modal && modal.parentElement !== document.body) document.body.appendChild(modal);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relocateModals, { once: true });
  } else {
    relocateModals();
  }
  
  /* Block background scroll via touchmove + wheel, with boundary
     chaining protection inside the sheet body. We intentionally do NOT
     set overflow:hidden on <html>/<body> - on mobile Safari / some
     Android browsers that forces the background page to jump upward
     when the sheet opens. This mirrors the delivery modal's approach. */
  var trustScrollLockId = null;
  function lockBackgroundScroll(modalEl) {
    if (trustScrollLockId !== null || !window.themeSheetScrollLock) return;
    trustScrollLockId = window.themeSheetScrollLock.lock(function () {
      return modalEl && modalEl.classList.contains('is-open')
        ? modalEl.querySelector('.trust-modal__content')
        : null;
    });
  }
  function unlockBackgroundScroll() {
    if (trustScrollLockId === null || !window.themeSheetScrollLock) return;
    window.themeSheetScrollLock.unlock(trustScrollLockId);
    trustScrollLockId = null;
  }

  function calculateEmi(price, months, interest, fee, note) {
    if (!Number.isSafeInteger(price) || price <= 0 || !Number.isInteger(months) || months < 1 || months > 120 || !/^0(?:\.0+)?%$/.test(interest.trim())) return null;
    var feeCents = null;
    var value = fee.trim();
    if (/^free$/i.test(value)) feeCents = 0;
    else if (/^AED\s*\d+(?:\.\d{1,2})?$/i.test(value)) feeCents = Math.round(Number(value.replace(/^AED\s*/i, '')) * 100);
    else if (/^\d+(?:\.\d+)?%$/.test(value)) feeCents = Math.round(price * Number(value.slice(0, -1)) / 100);
    if (note && !/^one-time$/i.test(note.trim())) feeCents = null;
    var monthly = Math.round(price / months);
    return { monthly: monthly, final: price - monthly * (months - 1), fee: feeCents, total: feeCents === null ? null : price + feeCents };
  }

  function updateEmi(modal) {
    var priceRoot = document.getElementById('price-' + modal.dataset.sectionId);
    var source = priceRoot && priceRoot.querySelector('[data-price-cents]');
    var price = source ? Number(source.dataset.priceCents) : 0;
    var ar = document.documentElement.lang.indexOf('ar') === 0;
    var money = function(cents) {
      return new Intl.NumberFormat(ar ? 'ar-AE' : 'en-AE', { style: 'currency', currency: 'AED' }).format(cents / 100);
    };
    modal.querySelectorAll('[data-emi-bank-panel]').forEach(function(panel) {
      var status = panel.querySelector('[data-emi-status]');
      var result = panel.querySelector('[data-emi-result]');
      var belowMinimum = price < Number(panel.dataset.emiMinimum);
      result.hidden = !source || price <= 0 || belowMinimum;
      panel.querySelector('[data-emi-price]').textContent = source && price > 0 ? money(price) : '—';
      status.textContent = !source || price <= 0
        ? (ar ? 'اختر منتجاً متاحاً بسعر صالح لعرض التقدير.' : 'Select an available priced product to see an estimate.')
        : belowMinimum
          ? (ar ? 'سعر هذا المنتج أقل من الحد الأدنى لهذا البنك.' : 'This item is below this bank’s minimum purchase.')
          : '';
      if (result.hidden) return;
      panel.querySelectorAll('[data-emi-plan]').forEach(function(plan) {
        var estimate = calculateEmi(price, Number(plan.dataset.months), plan.dataset.interest, plan.dataset.fee, plan.dataset.note);
        var unknown = ar ? 'يؤكده البنك' : 'Confirm with bank';
        var values = {
          monthly: estimate ? money(estimate.monthly) : unknown,
          final: estimate ? money(estimate.final) : unknown,
          fee: estimate && estimate.fee !== null ? (estimate.fee === 0 ? (ar ? 'بدون رسوم' : 'No fees') : money(estimate.fee) + (ar ? ' رسوم' : ' fee')) : plan.dataset.fee + (plan.dataset.note ? ' · ' + plan.dataset.note : ''),
          total: estimate && estimate.total !== null ? money(estimate.total) : unknown
        };
        Object.keys(values).forEach(function(key) { plan.querySelector('[data-emi-' + key + ']').textContent = values[key]; });
      });
    });
    if (modal._emiPriceRoot !== priceRoot) {
      if (modal._emiObserver) modal._emiObserver.disconnect();
      modal._emiPriceRoot = priceRoot;
      if (priceRoot) {
        modal._emiObserver = new MutationObserver(function() { updateEmi(modal); });
        modal._emiObserver.observe(priceRoot, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-price-cents'] });
      }
    }
  }

  document.addEventListener('change', function(event) {
    if (event.target.matches('.emi-bank-choice')) {
      var modal = event.target.closest('#emi-modal');
      if (modal) updateEmi(modal);
    }
  });

  function restoreTrustImages(modal) {
    modal.querySelectorAll('template[data-trust-image]').forEach(function (image) {
      image.replaceWith(image.content);
    });
  }

  function refreshEmiModal() {
    hydrateTrustModals();
    var modals = Array.from(document.querySelectorAll('[id="emi-modal"]'));
    var current = modals.find(function(modal) { return modal.parentElement !== document.body; }) || modals[0];
    if (!current) return;
    var wasOpen = modals.some(function(modal) { return modal.classList.contains('is-open'); });
    modals.forEach(function(modal) {
      if (modal === current) return;
      if (modal._emiObserver) modal._emiObserver.disconnect();
      if (modal._returnFocus) current._returnFocus = modal._returnFocus;
      modal.remove();
    });
    if (current.parentElement !== document.body) document.body.appendChild(current);
    if (!current.querySelector('.emi-bank-choice:checked')) {
      var firstBank = current.querySelector('.emi-bank-choice');
      if (firstBank) firstBank.checked = true;
    }
    if (wasOpen) {
      current.dataset.trustRenderReady = 'true';
      restoreTrustImages(current);
      unlockBackgroundScroll();
      current.classList.add('is-open');
      current.setAttribute('aria-hidden', 'false');
      setupSwipeToClose('emi-modal');
      lockBackgroundScroll(current);
      updateEmi(current);
    }
  }

  document.addEventListener('linkedOptionsLoaded', refreshEmiModal);

  // Global open function
  window.openTrustModal = function(modalId, opener) {
    if (modalId === 'emi-modal') refreshEmiModal();
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.dataset.trustRenderReady = 'true';
      restoreTrustImages(modal);
      // PDP section refreshes can replace EMI (and its listeners) without
      // re-running this deferred asset. Bind the current modal instance on
      // demand; setupSwipeToClose is idempotent for already-bound sheets.
      setupSwipeToClose(modalId);
      if (modalId === 'emi-modal') updateEmi(modal);
      var wasOpen = modal.classList.contains('is-open');
      if (!wasOpen) modal._returnFocus = opener || document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      if (modalId === 'emi-modal' && !wasOpen && typeof window.publishAlasilEvent === 'function') {
        window.publishAlasilEvent('alasil:storefront_interaction', { event_name: 'bnpl_info_viewed', provider: 'bank_emi' });
      }
      lockBackgroundScroll(modal);
      window.requestAnimationFrame(function() {
        if (!modal.isConnected || !modal.classList.contains('is-open')) return;
        var closeButton = modal.querySelector('.trust-modal__close');
        if (closeButton) closeButton.focus({ preventScroll: true });
      });
    }
  };

  /* Shopify policy routes return a flat stream of headings, paragraphs and
     lists. On the standalone page the editorial enhancer supplies layout,
     but inside a PDP modal that raw stream previously looked like an
     unformatted text document. Group each h2 and its following content into
     a semantic section so the modal can provide a compact, scannable policy
     layout without changing or duplicating any legal copy. */
  function enhanceFetchedPolicy(body) {
    if (!body || body.classList.contains('is-enhanced')) return;
    var contentRoot = body;
    var directElementChildren = Array.prototype.filter.call(body.children, function(node) {
      return node.nodeType === 1;
    });
    if (!body.querySelector(':scope > h2') && directElementChildren.length === 1 && directElementChildren[0].querySelector('h2')) {
      contentRoot = directElementChildren[0];
    }
    var sourceNodes = Array.prototype.slice.call(contentRoot.childNodes);
    var hasSections = sourceNodes.some(function(node) {
      return node.nodeType === 1 && node.matches('h2');
    });
    if (!hasSections) return;

    var fragment = document.createDocumentFragment();
    var preamble = document.createElement('div');
    preamble.className = 'trust-modal__policy-preamble';
    var section = null;

    sourceNodes.forEach(function(node) {
      if (node.nodeType === 1 && node.matches('h2')) {
        section = document.createElement('section');
        section.className = 'trust-modal__policy-section';
        section.appendChild(node);
        fragment.appendChild(section);
        return;
      }
      (section || preamble).appendChild(node);
    });

    if (preamble.textContent.trim() || preamble.querySelector('*')) {
      fragment.insertBefore(preamble, fragment.firstChild);
    }
    body.replaceChildren(fragment);
    body.classList.add('is-enhanced');
  }

  /* Policy documents are intentionally loaded only after the customer asks
     to read them. Keeping the full refund/contact HTML out of every storefront
     response reduces repeated main-content noise and the global HTML payload. */
  function ensurePolicyContent(modal) {
    var body = modal && modal.querySelector('.trust-modal__policy-body[data-policy-src]');
    if (!body || body.dataset.policyState === 'loaded' || body.dataset.policyState === 'loading') {
      return;
    }

    var src = body.getAttribute('data-policy-src');
    if (!src) return;
    body.dataset.policyState = 'loading';
    body.setAttribute('aria-busy', 'true');
    body.textContent = body.getAttribute('data-policy-loading') || 'Loading…';

    fetch(src, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Policy request failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var selectors = (body.getAttribute('data-policy-selector') || '.shopify-policy__body').split(',');
        var source = null;
        selectors.some(function (selector) {
          source = doc.querySelector(selector.trim());
          return Boolean(source);
        });
        if (!source) throw new Error('Policy content was not found');
        var isShopifyPolicyBody = source.classList.contains('shopify-policy__body');
        body.innerHTML = isShopifyPolicyBody ? source.innerHTML : source.outerHTML;
        if (isShopifyPolicyBody) enhanceFetchedPolicy(body);
        body.dataset.policyState = 'loaded';
      })
      .catch(function () {
        body.textContent = '';
        var message = document.createElement('p');
        message.textContent = body.getAttribute('data-policy-error') || 'This page could not be loaded.';
        var link = document.createElement('a');
        link.href = src;
        link.target = '_blank';
        link.rel = 'noopener';
        link.textContent = body.getAttribute('data-policy-link-label') || 'Open full page';
        body.appendChild(message);
        body.appendChild(link);
        body.dataset.policyState = 'error';
      })
      .finally(function () {
        body.removeAttribute('aria-busy');
      });
  }

  // Global close function
  window.closeTrustModal = function(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      unlockBackgroundScroll();
      if (modal._returnFocus && modal._returnFocus.isConnected) {
        modal._returnFocus.focus({ preventScroll: true });
      }
      /* Reset to default view after the close transition finishes so
         the next open always starts on the primary view instead of
         the policy view. Delayed so the swap isn't visible during
         the close animation. */
      setTimeout(function() {
        if (modal.classList.contains('is-open')) return;
        var def = modal.querySelector('[data-view="default"]');
        var pol = modal.querySelector('[data-view="policy"]');
        if (def && pol) {
          def.hidden = false;
          pol.hidden = true;
        }
        var scroll = modal.querySelector('.storefront-modal__sheet-body');
        if (scroll) scroll.scrollTop = 0;
      }, 320);
    }
  };
  
  /* Modal triggers can be relocated between the server-rendered PDP columns
     after this file initializes (Store Pickup is one example), and variant
     section refreshes can replace them entirely. Delegate from document so
     every current/future trust trigger remains interactive. Delivery owns a
     separate open flow; EMI uses this shared, section-refresh-safe handler. */
  var delegatedTrustModalIds = [
    'service-modal',
    'warranty-modal',
    'return-modal',
    'cod-modal',
    'store-pickup-modal',
    'purchase-protection-modal',
    'emi-modal'
  ];

  function getDelegatedTrustTrigger(target) {
    var trigger = target.closest && target.closest('[data-modal-trigger]');
    if (!trigger || delegatedTrustModalIds.indexOf(trigger.dataset.modalTrigger) === -1) return null;
    return trigger;
  }

  document.addEventListener('click', function(e) {
    var trigger = getDelegatedTrustTrigger(e.target);
    if (!trigger) return;
    e.preventDefault();
    openTrustModal(trigger.dataset.modalTrigger, trigger);
  });

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var trigger = getDelegatedTrustTrigger(e.target);
    if (!trigger) return;
    e.preventDefault();
    openTrustModal(trigger.dataset.modalTrigger, trigger);
  });

  // Close with Escape and keep keyboard focus inside the active dialog.
  document.addEventListener('keydown', function(e) {
    var activeModal = document.querySelector('.trust-modal.is-open');
    if (e.key === 'Tab' && activeModal) {
      var focusable = Array.prototype.slice.call(activeModal.querySelectorAll(
        'button:not([disabled]), a[href], details > summary, input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(function(el) {
        return el.getClientRects().length > 0;
      });
      if (focusable.length) {
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
    if (e.key === 'Escape') {
      ['service-modal', 'warranty-modal', 'return-modal', 'cod-modal', 'store-pickup-modal', 'purchase-protection-modal', 'emi-modal'].forEach(function(id) {
        const modal = document.getElementById(id);
        if (modal && modal.classList.contains('is-open')) {
          closeTrustModal(id);
        }
      });
    }
  });
  
  // Setup swipe-to-close for each modal (like simHelperModal)
  function setupSwipeToClose(modalId) {
    const modal = document.getElementById(modalId);
    if (!modal || modal.dataset.trustSwipeBound === 'true') return;
    
    const content = modal.querySelector('.trust-modal__content');
    if (!content) return;
    modal.dataset.trustSwipeBound = 'true';
    const scrollEl = modal.querySelector('.storefront-modal__sheet-body') || content;
    
    let touchStartY = 0;
    let touchCurrentY = 0;
    let isDragging = false;
    
    function isMobile() {
      return window.innerWidth < 768;
    }
    
    // Touch start - on entire content
    content.addEventListener('touchstart', function(e) {
      if (!isMobile() || !modal.classList.contains('is-open')) return;
      touchStartY = e.changedTouches[0].screenY;
      touchCurrentY = touchStartY;
      isDragging = true;
    }, { passive: true });
    
    // Touch move - track position and show visual feedback
    content.addEventListener('touchmove', function(e) {
      if (!isDragging || !isMobile()) return;
      touchCurrentY = e.changedTouches[0].screenY;
      const diff = touchCurrentY - touchStartY;
      
      if (diff > 0 && scrollEl.scrollTop <= 0) {
        content.style.transition = 'none';
        content.style.transform = 'translateY(' + Math.min(diff * 0.5, 150) + 'px)';
        
        const backdrop = modal.querySelector('.trust-modal__backdrop');
        if (backdrop) {
          backdrop.style.opacity = Math.max(0.3, 1 - (diff / 300));
        }
      }
    }, { passive: true });
    
    // Touch end - check if should close
    content.addEventListener('touchend', function(e) {
      if (!isDragging) return;
      isDragging = false;
      
      const diff = touchCurrentY - touchStartY;
      
      // Reset styles
      content.style.transition = 'transform 0.3s cubic-bezier(0.32, 0.72, 0, 1)';
      content.style.transform = '';
      
      const backdrop = modal.querySelector('.trust-modal__backdrop');
      if (backdrop) {
        backdrop.style.transition = 'opacity 0.3s ease';
        backdrop.style.opacity = '';
      }
      
      // Close if swiped down more than 100px
      if (diff > 100 && scrollEl.scrollTop <= 0) {
        closeTrustModal(modalId);
      }
      
      // Reset
      touchStartY = 0;
      touchCurrentY = 0;
    }, { passive: true });
  }
  
  // Initialize swipe for all modals
  setupSwipeToClose('service-modal');
  setupSwipeToClose('warranty-modal');
  setupSwipeToClose('return-modal');
  setupSwipeToClose('cod-modal');
  setupSwipeToClose('store-pickup-modal');
  setupSwipeToClose('purchase-protection-modal');
  setupSwipeToClose('emi-modal');

  /* In-place policy view swap with smooth height animation (FLIP).
     The bottom sheet content height is measured before and after the
     view switch, then animated from start → end so the resize feels
     fluid instead of snapping. */
  function getSheetContent(modal) {
    return modal.querySelector('.trust-modal__content, .delivery-modal__content, .bnpl-modal__content');
  }

  function animateSheetResize(modal, swap) {
    var content = getSheetContent(modal);
    if (!content) { swap(); return; }

    var startHeight = content.getBoundingClientRect().height;

    /* Run the swap so we can measure target height */
    swap();

    /* Force layout: temporarily clear any inline height so the new
       content lays out at its natural size. */
    content.style.transition = 'none';
    content.style.height = 'auto';
    var endHeight = content.getBoundingClientRect().height;

    /* Cap at the same max-height the CSS uses so we don't exceed
       the viewport on long policy bodies. */
    var cap = Math.min(window.innerHeight * 0.8, 720);
    if (endHeight > cap) endHeight = cap;

    /* Set explicit start height, force reflow, then transition to end. */
    content.style.height = startHeight + 'px';
    void content.offsetHeight;
    content.style.transition = 'height 0.36s cubic-bezier(0.32, 0.72, 0, 1)';
    content.style.height = endHeight + 'px';

    var cleanup = function () {
      content.removeEventListener('transitionend', cleanup);
      content.style.transition = '';
      content.style.height = '';
    };
    content.addEventListener('transitionend', cleanup);
    /* Safety: if transitionend doesn't fire (interrupted), clean up anyway. */
    setTimeout(cleanup, 500);
  }

  window.trustModalShowPolicy = function(modalId) {
    var modal = document.getElementById(modalId);
    if (!modal) return;
    var def = modal.querySelector('[data-view="default"]');
    var pol = modal.querySelector('[data-view="policy"]');
    if (!def || !pol) return;
    ensurePolicyContent(modal);
    /* Desktop inline-panel case: the button lives inside the product's
       inline <details> panel, NOT inside the modal. The modal itself
       is still closed (visibility:hidden), so a plain view swap would
       be invisible. Pre-select the policy view and open the modal. */
    if (!modal.classList.contains('is-open')) {
      def.hidden = true;
      pol.hidden = false;
      var sb = modal.querySelector('.storefront-modal__sheet-body');
      if (sb) sb.scrollTop = 0;
      if (modalId === 'delivery-modal' && typeof window.openDeliveryModal === 'function') {
        window.openDeliveryModal();
      } else if (typeof window.openTrustModal === 'function') {
        window.openTrustModal(modalId);
      }
      return;
    }
    /* Modal already open (mobile bottom sheet flow): in-place view
       swap with smooth height animation. */
    animateSheetResize(modal, function () {
      def.hidden = true;
      pol.hidden = false;
      var scroll = modal.querySelector('.storefront-modal__sheet-body');
      if (scroll) scroll.scrollTop = 0;
    });
  };
  window.trustModalBack = function(modalId) {
    var modal = document.getElementById(modalId);
    if (!modal) return;
    var def = modal.querySelector('[data-view="default"]');
    var pol = modal.querySelector('[data-view="policy"]');
    if (!def || !pol) return;
    animateSheetResize(modal, function () {
      pol.hidden = true;
      def.hidden = false;
      var scroll = modal.querySelector('.storefront-modal__sheet-body');
      if (scroll) scroll.scrollTop = 0;
    });
  };
  
  // Prevent background scroll when modal is open
  function preventBackgroundScroll(e) {
    const isModalOpen = document.body.classList.contains('trust-modal-open');
    if (!isModalOpen) return;
    
    // Check if touch is on modal content
    const modalContent = e.target.closest('.trust-modal__content');
    if (modalContent) {
      // Allow scroll inside modal content
      return;
    }
    
    // Prevent scroll on backdrop/body
    e.preventDefault();
  }
  
  // Add passive: false to allow preventDefault
  document.addEventListener('touchmove', preventBackgroundScroll, { passive: false });

  document.addEventListener('click', function (e) {
    const summary = e.target.closest('.trust-item-details--warranty summary');
    if (!summary) return;
    if (window.innerWidth >= 768) return;
    e.preventDefault();
    const det = summary.closest('details');
    if (det) det.removeAttribute('open');
    openTrustModal('warranty-modal');
  }, true);

  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const summary = e.target.closest('.trust-item-details--warranty summary');
      if (!summary) return;
      if (window.innerWidth >= 768) return;
      e.preventDefault();
      const det = summary.closest('details');
      if (det) det.removeAttribute('open');
      openTrustModal('warranty-modal');
    },
    true
  );
})();
